<template>
  <v-card class="pa-4" :loading="loadingData">
    <v-card-title>
      Netto-Umsätze des eigenen Betriebes im Vergleich zum Durchschnitt im Jahr
      {{ selectedYear }}
    </v-card-title>
    <v-card-text v-if="!loadingData">
      <custom-chart :chartdata="cahrtData" />
    </v-card-text>
  </v-card>
</template>

<script>
import generateChartData from "../../utils/generateChartData";
import customChart from "../../components/customChart.vue";

export default {
  data() {
    return {
      cahrtData: null,
      apiPath: this.generateAPIPath(),
      loadingData: true,
    };
  },
  components: {
    customChart,
  },
  props: {
    selectedUser: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
    selectedYear: {
      type: Number,
      required: true,
    },
  },
  watch: {
    selectedUser: async function () {
      await this.setupChartData();
    },
    selectedYear: async function () {
      await this.setupChartData();
    },
  },
  methods: {
    generateAPIPath: function () {
      if (this.isAdmin) {
        return "/api/admin/";
      }
      return "/api/getDataUmsatzmonitor/";
    },
    setupChartData: async function () {
      this.loadingData = true;
      //Labels Vorbereiten

      //Größen Wörterbuch bereitstellen:
      let companySizeDictionary = {
        Big: "Große",
        Medium: "Mittelgroße",
        Small: "Kleine",
      };

      //Region Wörterbuch bereitstellen:
      let companyRegionDictionary = {
        South: "Süden",
        North: "Norden",
      };

      //Größenfattegorie ins Deutsche Übersetzen
      let companySizeDE = companySizeDictionary[this.selectedUser.companySize];

      //Region ins Deutsche Übersetzen
      let regionDE = companyRegionDictionary[this.selectedUser.region];

      let dataReq = [];
      dataReq.push({
        apiQuerryPath: this.apiPath + "getCompaniDataYear",
        apiQuerryData: {
          year: this.selectedYear,
          email: this.selectedUser.email,
        },
        labels: [this.selectedUser.companyName],
        subVariable: ["summe"],
      });
      dataReq.push({
        apiQuerryPath: this.apiPath + "getAverageDataYear",
        apiQuerryData: {
          year: this.selectedYear,
          email: this.selectedUser.email,
          filter: {
            thresholdAverage: 8,
          },
        },
        labels: ["Ø Alle"],
        subVariable: ["summe"],
        tooltipInfo: {
          variable: "count",
          appendText: " Einträge ergeben diesen Durchschnitt",
        },
      });

      dataReq.push({
        apiQuerryPath: this.apiPath + "getAverageDataYear",
        apiQuerryData: {
          year: this.selectedYear,
          email: this.selectedUser.email,
          filter: {
            filterOnCompanySize: true,
          },
        },
        labels: ["Ø " + companySizeDE + " Unternehmen"],
        subVariable: ["summe"],
        tooltipInfo: {
          variable: "count",
          appendText: " Einträge ergeben diesen Durchschnitt",
        },
      });
      dataReq.push({
        apiQuerryPath: this.apiPath + "getAverageDataYear",
        apiQuerryData: {
          year: this.selectedYear,
          email: this.selectedUser.email,
          filter: {
            filterOnRegion: true,
          },
        },
        labels: ["Ø " + regionDE],
        subVariable: ["summe"],
        tooltipInfo: {
          variable: "count",
          appendText: " Einträge ergeben diesen Durchschnitt",
        },
      });
      dataReq.push({
        apiQuerryPath: this.apiPath + "getAverageDataYear",
        apiQuerryData: {
          year: this.selectedYear,
          email: this.selectedUser.email,
          filter: {
            filterOnFederalState: true,
          },
        },
        labels: ["Ø " + this.selectedUser.federalState],
        subVariable: ["summe"],
        tooltipInfo: {
          variable: "count",
          appendText: " Einträge ergeben diesen Durchschnitt",
        },
      });

      this.cahrtData = await generateChartData(dataReq);
      this.loadingData = false;
    },
  },

  mounted: async function () {
    await this.setupChartData();
  },
};
</script>
<style></style>
